import { render, staticRenderFns } from "./MaterialColorPicker.vue.js?vue&type=template&id=1a620b0b&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialColorPicker.vue?vue&type=template&id=1a620b0b&scoped=true"
import script from "./MaterialColorPicker.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialColorPicker.vue?vue&type=script&lang=js"
export * from "./MaterialColorPicker.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialColorPicker.vue?vue&type=script&lang=js"
import style0 from "./MaterialColorPicker.vue.scss?vue&type=style&index=0&id=1a620b0b&prod&lang=scss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialColorPicker.vue?vue&type=style&index=0&id=1a620b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a620b0b",
  null
  
)

export default component.exports